import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/auth';

export const AccountPage = () => {
  const { profile, partners, selectedPartnerId, setSelectedPartnerId, logout } = useAuth();

  return (
    <div className="mx-auto flex max-w-xl flex-col gap-6 px-4 py-5">
      <h2>アカウント</h2>

      <section className="border border-neutral-200 px-4 py-3">
        <p className="font-bold">{profile?.username}</p>
        <p className="text-sm text-neutral-600">{profile?.email}</p>
      </section>

      {partners.length > 1 && (
        <section className="flex flex-col gap-2">
          <h3 className="text-base">発注先を切り替え</h3>
          <div className="divide-y divide-neutral-200 border border-neutral-200">
            {partners.map((partner) => (
              <label key={partner.id} className="flex min-h-14 cursor-pointer items-center gap-3 px-4">
                <input
                  type="radio"
                  name="partner"
                  checked={partner.id === selectedPartnerId}
                  onChange={() => setSelectedPartnerId(partner.id)}
                  className="size-5 accent-sky-800"
                />
                <span>{partner.supplier_name}</span>
              </label>
            ))}
          </div>
          <p className="text-sm text-neutral-600">
            切り替えると、発注・商品の表示が選択した発注先のものになります。
          </p>
        </section>
      )}

      <Button variant="outlined" size="lg" fullWidth onClick={logout}>
        ログアウト
      </Button>
    </div>
  );
};
